import Phaser, { Scene } from 'phaser'
import AlertPoints from '../components/alertPoints'
import BtnEndGame from '../components/btn-endgame'
import Counter from '../components/counter'
import Logo from '../components/logo'
import Points from '../components/points'
import Shot from '../components/shot'
import ShootButton from '../components/shot-button'
import {
  HOME_ELEMENST,
  HOME_SPRITE_SHEETS,
} from '../constants/assets-constants'
import { GAME_CONFIG, QUESTIONS_LIST } from '../constants/game-constants'
import GameDataLayer from '../utils/game-datalayer'
import GameSounds from '../utils/game-sounds'
import GameUtil from '../utils/game-util'
export default class HomeScene extends Scene {
  customComponents = []

  constructor() {
    super({
      key: 'home',
      type: Phaser.AUTO,
      active: true,
      physics: {
        default: 'arcade',
        arcade: { debug: false, gravity: { X: 0, Y: 0 } },
      },
    })
  }

  init() {
    this.target = 0
    this.data.values.POINTS = parseInt(this.game.reactProps?.defaultPoints || 0)

    this.isMobile = this.game.reactProps?.isMobile ?? false
    this.data.set('questionsList', QUESTIONS_LIST)

    //create custom components
    //logo, points, btn-endgame
    this.logoObj = new Logo(this)
    this.pointsObj = new Points(this)
    this.alertPoints = new AlertPoints(this)
    this.counter = new Counter(this)
    this.btnEndGame = new BtnEndGame(this, () => {
      GameDataLayer.finishGameDataLayer()
      this.onFinishGame(true)
    })
    this.customComponents.push(
      this.logoObj,
      this.pointsObj,
      this.btnEndGame,
      this.alertPoints,
      this.counter
    )

    //shot object
    this.shotObject = new Shot(this)
    this.customComponents.push(this.shotObject)

    this.shotObject = new Shot(this)
    this.customComponents.push(this.shotObject)

    if (this.isMobile) {
      this.shotButtonObject = new ShootButton(this)
      this.customComponents.push(this.shotButtonObject)
    }

    //Game sounds
    this.gameSounds = new GameSounds(this)
    this.customComponents.push(this.gameSounds)
  }

  preload() {
    let device = this.isMobile ? 'mobile' : 'desktop'
    for (let img in HOME_ELEMENST) {
      let url =
        HOME_ELEMENST[img][device] ??
        HOME_ELEMENST[img]?.mobile ??
        HOME_ELEMENST[img]?.desktop ??
        HOME_ELEMENST[img]
      this.load.image(`${img}`, url)
    }

    HOME_SPRITE_SHEETS.forEach(spriteSheet => {
      this.load.spritesheet(spriteSheet.key, spriteSheet.url, {
        frameWidth: spriteSheet.frameWidth,
        frameHeight: spriteSheet.frameHeight,
      })
    })

    this.customComponents.forEach(
      component => component?.preload && component.preload()
    )
  }

  create() {
    this.createPinkScenary()
    this.createQuestionsObject()
    this.customComponents.forEach(
      component => component?.create && component.create()
    )

    this.addEvents()

    var config2 = {
      key: 'explode',
      frames: this.anims.generateFrameNumbers('boom', {
        start: 0,
        end: 23,
        first: 23,
      }),
      frameRate: 20,
    }

    this.anims.create(config2)
  }

  update() {
    this.customComponents.forEach(
      component => component?.update && component.update()
    )

    if (this.flecha) this.flecha.rotation = this.target
  }

  addEvents() {
    //on pointer move
    this.input.on(
      'pointermove',
      position => {
        this.calcArrowAngle(position)
        if (localStorage.getItem('IS_PAUSED') === 'true') this.unpause()
      },
      this
    )

    //on Shoot
    let spaceKeyCode = Phaser.Input.Keyboard.KeyCodes.SPACE
    let keySpace = this.input.keyboard.addKey(spaceKeyCode)
    keySpace.on('up', this.fireAShot, this)

    //create bonus gotas
    this.time.addEvent({
      delay: GAME_CONFIG.TIME_BETWEEN_BONUS,
      callback: this.createRamdonBonus,
      callbackScope: this,
      loop: true,
    })
  }

  createRamdonBonus(e) {
    let hexaStrinColor = 0xff00ff
    for (let index = 0; index < GAME_CONFIG.BONUS_PER_TIME; index++) {
      let randomBonus = this.getRandomGota()
      if (
        !randomBonus.getData('isQuestion') &&
        !randomBonus.getData('isBonus') &&
        randomBonus.active
      ) {
        randomBonus.setTintFill(hexaStrinColor)
        randomBonus.on(
          'destroy',
          () => {
            GameDataLayer.bonusTackDataLayer()
            this.alertPoints.showAlert('One')
            this.addPoints(GAME_CONFIG.POINTS_PER_BONUS)
          },
          this
        )

        this.time.addEvent({
          delay: GAME_CONFIG.TIME_BETWEEN_BONUS,
          callback: () => this.removeRandomBonus(randomBonus),
          callbackScope: this,
        })
      }
    }
  }

  removeRandomBonus(bonus) {
    bonus.clearTint()
    bonus.removeListener('destroy')
  }

  createQuestionsObject() {
    let questions = this.data.get('questionsList')
    for (let i = 0; i < questions.length; i++) {
      this.createRandomQuestion()
    }
  }

  fireAShot() {
    if (localStorage.getItem('IS_PAUSED' === 'true')) return false

    this.toallaAnimation()
    this.gameSounds.Sounds.spaceLaser.play()

    this.shotObject.Shot.refreshBody()
    this.shotObject.Shot.enableBody(
      true,
      this.flecha.x,
      this.flecha.y,
      true,
      true
    )
    this.physics.velocityFromRotation(
      this.target,
      GAME_CONFIG.SPEED,
      this.shotObject.Shot.body.velocity
    )
  }

  calcArrowAngle(pointer) {
    this.target = Phaser.Math.Angle.BetweenPoints(this.flecha, pointer)
  }

  unpause() {
    localStorage.setItem('IS_PAUSED', false)
    let isCorrectAnswer = localStorage.getItem('CORRECT_ANSWER')
    let questions = this.data.get('questionsList')
    if (isCorrectAnswer === 'true') {
      this.onCorrectAnswer()
      questions?.length === 0 && this.onFinishGame(true)
    } else if (isCorrectAnswer === 'false') {
      this.onFinishGame()
    }
  }

  onShowQuestion(shot, questionBox) {
    shot.disableBody(true, true)
    let hitCount = questionBox.getData('hitCount') || 1
    
    if (hitCount < GAME_CONFIG.SHOOTS_PER_BOX) {
      this.counter.showCount({ count: hitCount, element: questionBox })
      questionBox.setData('hitCount', ++hitCount)
      return
    }
    
    questionBox.disableBody(true, false)
    this.gameSounds.Sounds.smokeBomb.play()
    questionBox.anims.play('explode')
    this.alertPoints.showAlert('Three')

    this.time.addEvent({
      delay: 1500,
      callback: () => {
        questionBox.destroy()
        this.data.values.POINTS += GAME_CONFIG.POINTS_PER_BOX_DESTROYED
        this.game.reactProps?.onShowQuestion(this.getRamdoQuestion())
      },
      callbackScope: this,
      loop: false,
    })
  }

  onCorrectAnswer() {
    this.alertPoints.showAlert('Six')
    this.addPoints(GAME_CONFIG.POINTS_PER_QUESTION)
  }

  onFinishGame(isWinner = false) {
    this.game.reactProps?.onFinishGame({
      isWinner,
      points: this.data.values.POINTS,
    })
  }

  //creation Elements
  createPinkScenary() {
    let canvasHeight = this.sys.canvas.height

    //pink platform
    let platformSizes = {
      Y: this.isMobile ? 70 : 100,
      X: this.isMobile ? 100 : 75,
    }

    let platformPercentaje = GameUtil.getViewPercentage(platformSizes, this)
    let plataforma = this.add
      .image(0, 0, 'plataformaRosa')
      .setOrigin(0, 0)
      .setDisplaySize(platformPercentaje.X, platformPercentaje.Y)
      .setInteractive()
    plataforma.setPosition(0, (canvasHeight - plataforma.displayHeight) / 2)
    GameUtil.resetSize(plataforma)
    this.plataforma = plataforma

    //plataforma toalla
    this.plataformaToalla = this.physics.add
      .image(0, 0, 'plataformaToalla')
      .setScale(this.isMobile ? 0.7 : 1)
      .setDepth(1)
    Phaser.Display.Align.In.BottomCenter(
      this.plataformaToalla,
      plataforma,
      0,
      -7
    )

    //toalla
    this.toalla = this.physics.add
      .image(0, 0, 'toalla')
      .setScale(this.isMobile ? 0.7 : 1)
      .setDepth(1)
      .setInteractive()

    this.toalla.on('pointerdown', () => GameDataLayer.toallaDataLayer(), this)
    GameUtil.resetSize(this.toalla)
    Phaser.Display.Align.In.BottomCenter(
      this.toalla,
      this.plataformaToalla,
      0,
      -10
    )

    //flecha
    let flechaOffset = GameUtil.getViewPercentage(
      { X: 20, Y: -20 },
      this.toalla
    )
    this.flecha = this.add
      .image(0, 0, 'flechaRosa')
      .setOrigin(0, 0.5)
      .setDepth(1)
    Phaser.Display.Align.In.TopCenter(
      this.flecha,
      this.toalla,
      flechaOffset.X,
      flechaOffset.Y
    )

    //gotas rojas
    let padding = 10
    let cellWidth = 20 + padding
    let columnsNumber = 7
    let gotasPlatformSize = GameUtil.getViewPercentage(
      { X: this.isMobile ? 75 : 80 },
      plataforma
    )
    let gotasPorFila = gotasPlatformSize.X / cellWidth
    let gotasPorFilaRound = Phaser.Math.RoundTo(gotasPorFila)
    let InitialPosition = GameUtil.getViewPercentage(
      { X: this.isMobile ? 14 : 10, Y: 10 },
      plataforma
    )

    this.gotasRojas = this.physics.add.staticGroup()

    this.createDropRow({
      group: this.gotasRojas,
      gotasPorFila: gotasPorFilaRound,
      columnsNumber,
      cellWidth,
      InitialPosition: {
        X:
          InitialPosition.X +
          Math.abs(gotasPorFilaRound - gotasPorFila) * cellWidth,
        Y: InitialPosition.Y + plataforma.y,
      },
    })
  }

  createQuestionBox(destroyedObj) {
    let questionBox = this.physics.add
      .staticSprite(destroyedObj.x, destroyedObj.y, 'cuadroPregunta')
      .setOrigin(0.5)
      .setDepth(1)

    this.physics.add.collider(
      this.shotObject.Shot,
      questionBox,
      this.onShowQuestion,
      null,
      this
    )
  }

  createDropRow({
    group,
    gotasPorFila,
    columnsNumber,
    cellWidth,
    InitialPosition,
  }) {
    for (let i = 0; i < columnsNumber; i++) {
      let isPair = i % 2 === 0
      let cellHeight = this.isMobile ? 25 : 40
      let dropsPerRow = gotasPorFila - (isPair ? 1 : 0)

      group.createMultiple({
        key: 'gotaRoja',
        quantity: dropsPerRow,
        max: dropsPerRow,
        gridAlign: {
          cellWidth: cellWidth,
          cellHeight: cellHeight,
          position: Phaser.Display.Align.TOP_CENTER,
          x: InitialPosition.X + (isPair ? cellWidth / 2 : 0),
          y: InitialPosition.Y + cellHeight * i,
        },
      })
    }
  }

  getRamdoQuestion() {
    let questions = this.data.get('questionsList')
    let randomIndex = Math.floor(Math.random() * questions.length)

    let randomQuestion = questions[randomIndex]
    questions.splice(randomIndex, 1)

    this.data.set('questionsList', questions)
    return randomQuestion
  }

  createRandomQuestion() {
    let randomGota = this.getRandomGota()
    if (!randomGota.getData('isQuestion')) {
      let hexaStrinColor = 0x001863
      randomGota.setTintFill(hexaStrinColor)
      randomGota.setData('isQuestion', true)
      randomGota.on('destroy', this.createQuestionBox, this)
    } else {
      this.createRandomQuestion()
    }
  }

  toallaAnimation() {
    this.toalla.y += 7

    this.time.addEvent({
      delay: 300,
      callback: () => {
        this.toalla.y -= 7
      },
      callbackScope: this,
      loop: false,
    })
  }

  getRandomGota() {
    let GetRandom = Phaser.Utils.Array.GetRandom
    return GetRandom(this.gotasRojas.getChildren())
  }

  addPoints(points) {
    this.data.values.POINTS += points
  }
}
